module.exports = __webpack_public_path__ + "static/media/mastercard.d9297d80.svg";